import { render, staticRenderFns } from "./twwt.vue?vue&type=template&id=dd0b567a&scoped=true&"
import script from "./twwt.vue?vue&type=script&lang=js&"
export * from "./twwt.vue?vue&type=script&lang=js&"
import style0 from "./twwt.vue?vue&type=style&index=0&id=dd0b567a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0b567a",
  null
  
)

export default component.exports